<template>
  <div :class="type" class="app-header">
    <img v-if="locale === 'vi'" class="logo" src="@/assets/imgs/logo-vi.png" alt="logo">
    <img v-else-if="locale === 'hk' || locale === 'tw'" class="logo" :class="{'logo-hk': locale === 'hk' || locale === 'tw'}" src="@/assets/imgs/logo-hk.png" alt="logo">
    <img v-else class="logo" src="@/assets/imgs/logo.png" alt="logo">
    <div class="lang-selection" 
      @click="toggleLangList"
      @mouseenter="onPcHover"
      @mouseleave="showLangList = false"
      :class="{ 'lang-selected': isLangSelected, 'show-lang-list': showLangList }"
    >
      <div class="lang-icon"></div>
      <div class="selected-lang">{{ langMap[locale] }}</div>
      <div class="lang-arrow" :class="{'arrow-rotate': showLangList}"></div>
      <div class="lang-list" v-show="showLangList">
        <div
          class="lang-item" 
          v-for="item in langList" 
          :key="item.value"
          @click="changeLang(item.value); $event.stopPropagation();"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import { langMap, supportedLangs } from '@/config/lang'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
const store = useStore()
const router = useRouter()
const type = isMobile ? 'mobile' : 'pc'
const { locale } = useI18n()
const showLangList = ref(false)
const isLangSelected = ref(false)

const langList = computed(() => {
  return supportedLangs.map(lang => ({
    label: langMap[lang],
    value: lang
  }))
})

// 切换语言列表显示/隐藏
const toggleLangList = () => {
  if (isMobile) {
    showLangList.value = !showLangList.value
  }
}

// 切换语言
const changeLang = (lang) => {
  locale.value = lang
  store.commit('SET_LOCALE', lang)
  showLangList.value = false
  isLangSelected.value = true
  
  // 延迟重置状态，给用户足够时间移开鼠标
  setTimeout(() => {
    isLangSelected.value = false
  }, 500)
  
  router.push({ path: '/' + lang })
}

// 点击外部关闭下拉框
const closeDropdown = (e) => {
  if (!e.target.closest('.lang-selection')) {
    showLangList.value = false
  }
}

// 在PC端鼠标悬停时显示语言列表
const onPcHover = () => {
  if (!isMobile) {
    showLangList.value = true
  }
}

// 添加点击事件监听
onMounted(() => {
  document.addEventListener('click', closeDropdown)
})

// 组件卸载时移除监听
onUnmounted(() => {
  document.removeEventListener('click', closeDropdown)
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
